exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-08096bfe] .el-date-editor.el-input{width:125px}", ""]);

// exports
